import { useEffect, useState } from "react";
import { API_BASE } from "../../config/apiConfig";

import MedalTallyCard from "../../components/performanceReview/medalTallyCard";
import MostImprovedCard from "../../components/performanceReview/mostImprovedCard";
import MostImprovedAJSSCard from "../../components/performanceReview/mostImprovedAJSSCard";
import HighestRankedCard from "../../components/performanceReview/highestRankedCard";
import TeamTrendsChart from "../../components/performanceReview/teamTrendsChart";

import NavButtons from "../../components/navButtons";
import PageHeader from "../../components/pageHeader";
import MainContentLayout from "../../components/mainContentLayout";
import LoadingOverlay from "../../components/loadingOverlay";

export default function AdminPerformanceReviewLanding() {
  const token = sessionStorage.getItem("access_token");

  const [results, setResults] = useState([]);
  const [ajss, setAjss] = useState([]);
  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [loading, setLoading] = useState(false);

  // ------------------------------------------------------------
  // FETCH ALL DATA
  // ------------------------------------------------------------
  useEffect(() => {
    loadData();
  }, []);

  async function loadData() {
    setLoading(true);

    try {
      // -------------------------------------------
      // 1. Fetch RESULTS
      // -------------------------------------------
      const res1 = await fetch(`${API_BASE}/api/performance-results`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const resultsData = await res1.json();
      setResults(resultsData?.results || []);

      // -------------------------------------------
      // 2. Fetch AJSS Rankings
      // -------------------------------------------
      const res2 = await fetch(`${API_BASE}/api/performance-ajss`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const ajssData = await res2.json();
      setAjss(ajssData?.ajss || []);

      // -------------------------------------------
      // 3. Extract unique years
      // -------------------------------------------
      const yearList = [
        ...new Set((ajssData?.ajss || []).map(item => Number(item.year)))
      ].sort((a, b) => b - a);

      setYears(yearList);
      if (yearList.length > 0) {
        setSelectedYear(yearList[0]); // default = latest year
      }

    } catch (err) {
      console.error("Error loading performance data:", err);
    } finally {
      setLoading(false);
    }
  }

  // ------------------------------------------------------------
  // FILTER DATA
  // ------------------------------------------------------------
  const filteredResults = selectedYear
    ? results.filter(r => Number(r.year) === Number(selectedYear))
    : results;

  const filteredAJSS = selectedYear
    ? ajss.filter(a => Number(a.year) === Number(selectedYear))
    : ajss;

  // ------------------------------------------------------------
  // UI
  // ------------------------------------------------------------
  return (
    <MainContentLayout>
      <PageHeader title="Performance Review" backTo="/dashboard" />

      <LoadingOverlay show={loading} />

      <div className="my-6 w-full pb-4">
        <NavButtons />
      </div>

      {/* Year selector */}
      <div className="flex justify-end my-4">
        <select
          value={selectedYear || ""}
          onChange={(e) => setSelectedYear(Number(e.target.value))}
          className="border border-gray-400 rounded px-3 py-2"
        >
          {years.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>

      {/* Cards */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 my-4">

        {/* Medal Tally */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-4">
          <MedalTallyCard results={filteredResults} />
        </div>

        {/* Most Improved (National) */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2">
          <MostImprovedCard results={filteredResults} />
        </div>

        {/* Most Improved (AJSS) */}
        <div className="col-span-1 sm:col-span-1 lg:col-span-2">
          <MostImprovedAJSSCard ajss={filteredAJSS} selectedYear={selectedYear} />
        </div>

        {/* Highest Ranked */}
        <div className="col-span-1 sm:col-span-2 lg:col-span-4">
          <HighestRankedCard ajss={ajss} />
        </div>

      </div>

      {/* AJSS Trends */}
      <div className="grid grid-cols-1 gap-6 my-4">
        <TeamTrendsChart ajss={filteredAJSS} selectedYear={selectedYear} />
      </div>
    </MainContentLayout>
  );
}
